var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 12.3125H18.6875V7H13.3125V12.3125H9.3125L16 19L22.6875 12.3125ZM25.8125 8.375C27.5208 8.5 28.9792 9.20833 30.1875 10.5C31.3958 11.75 32 13.25 32 15C32 16.8333 31.3333 18.4167 30 19.75C28.7083 21.0417 27.1458 21.6875 25.3125 21.6875H8C5.79167 21.6875 3.89583 20.9167 2.3125 19.375C0.770833 17.7917 0 15.8958 0 13.6875C0 11.7292 0.6875 9.97917 2.0625 8.4375C3.47917 6.85417 5.16667 5.95833 7.125 5.75C8 4.125 9.22917 2.8125 10.8125 1.8125C12.3958 0.8125 14.125 0.3125 16 0.3125C18.25 0.3125 20.3333 1.10417 22.25 2.6875C24.2083 4.27083 25.3958 6.16667 25.8125 8.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.7b8f35e3.svg";
export { ForwardRef as ReactComponent };